import { _on } from '../../utils';

_on('click', 'js--drawer-close', () => {
  document.body.classList.remove('drawer--active');
});

_on('click', 'js--drawer', () => {
  document.body.classList.add('drawer--active');
});

_on('click', 'js--drawer-overlay', () => {
  document.body.classList.remove('drawer--active');
});
